import { css } from '@emotion/react'
import type { CSSObject } from '@emotion/react'
import { Color, OppositeTheme, Spacing, Typography } from '@opallabs/gem'
import type { Theme } from '@opallabs/gem'

const text = css({
  ...Typography.T300,
  // @note This spacing should be applied by the parent component
  //   (`<PostSchedule>`), but that's currently styled with SCSS, not Gem.
  marginBlockStart: Spacing.S,
})
const textColor = (theme: Theme): CSSObject => ({
  color: Color[theme].Text.Gray,

  '@media (prefers-contrast: more)': {
    color: Color[OppositeTheme[theme]].Surface.N500,
  },
})

const difference = css({
  fontStyle: 'normal',
})

const highlightedText = (theme: Theme): CSSObject => ({
  color: Color[theme].Text.Default,

  '@media (prefers-contrast: less)': {
    color: 'inherit',
  },
})

export const styles = {
  difference,
  highlightedText,
  text,
  textColor,
} as const
